import { createUseStyles } from "react-jss";
import { breakpoints } from "../../constants/breakpoints";
import { colors } from "../../constants/colors";
import checkIcon from "../../resources/images/check-blue.svg";
import minusIcon from "../../resources/images/minus-icon-blue.svg";

const styles = createUseStyles(theme => ({
  modalContent: {
    overflowY: 'scroll',
    height:"100%"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  checkbox: {
    marginRight: "12px"
  },
  bannerPresentStyle: {
    marginTop: "52px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginTop: "122px",
    },
  },
  pendingInvitationModal: {
    fontFamily: theme.fontFamily,
    "&.offcanvas":{
      width: "680px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    },
    "& .offcanvas-content":{
      width: "680px",
      height:"800px",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        width: "380px",
      },
    },
    "& .offcanvas-body":{
      padding:"0px 0px 0px 0px",
      textAlign:"center",
    },
    "& .offcanvas-title":{
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        padding:"0px 12px",
      },
    },
    "& .offcanvas-header":{
      padding:"40px 24px 0px 24px",
      "& .btn-close" : {
        marginBottom: "auto",
        fontSize: "12px",
        position: "relative",
        top: "3px",
        right: "7px",
        [`@media (max-width: ${breakpoints.sm}px)`]: {
          right:"18px",
        },
      },
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        padding:"20px 12px 0px",
      },
    },
  },
  titleStyle: {
    fontSize: "20px",
    color: colors.lightBlack,
    fontWeight:"600",
    lineHeight:"30px",
    textAlign:"left",
  },
  descriptionStyle:{
    fontSize: "14px",
    color: colors.mediumGrey,
    fontWeight:"400",
    lineHeight:"20px",
    textAlign:"left",
    margin: "4px 0 8px 0"
  },
  cancelBtn: {
    extend: "footerBtns"
  },
  saveBtn: {
    extend: "footerBtns"
  },
  dividerContainer:{
    display: "flex",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginRight:"-12px",
      marginLeft:"-12px",
      width: "165%"
    },
  },
  border:{
    width: "100%",
    color: colors.lightGrey,
    opacity: 1,
  },
  search: {
    width:"320px",
    height:"44px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width:"250px",
    }
  },
  sortIcon:{
    padding: "10px",
    cursor: "pointer",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: 0
    },
  },
  actionContainer:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    padding:"8px 0px 16px 0px",    
    margin: "0px 24px"
  },
  dotsOpenStyle: {
    "& path": {
      stroke: colors.grey
    }
  },
  actionButtonContainer:{
    display:"flex",
    alignItems:"center",
    marginLeft: "auto"
  },
  mailContainer:{
    padding: "16px 12px",
    display:"flex",
    flexDirection:"column",
    alignItems:"flex-start",
    fontSize: "14px",
    color: colors.lightBlack,
    fontWeight:"400",
    lineHeight:"20px",
  },
  customLoading: {
    pointerEvents: "none",
    "& span": {
      borderColor: `${colors.grey} ${colors.grey} transparent !important`
    }
  },
  sendBtn:{
    padding:"10px",
    border: "1px solid " + colors.darkGrey,
    borderRadius: "8px",
    "& svg":{
      width:"20px",
      height:"20px",
    },
    "& span":{
      display: "flex",
      alignItems: "center"
    },
    "&:hover":{
      cursor: "pointer",
      backgroundColor:colors.brightBlue,
      borderRadius: 8,
    },
  },
  pendingContent: {
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "160%"
    },
  },
  deleteBtn:{
    border: "1px solid " + colors.mediumRed,
    borderRadius: "8px",
    padding:"10px",
    marginLeft:"8px",
    "& span":{
      display: "flex",
      alignItems: "center"
    },
    "& svg":{
      width:"20px",
      height:"20px",
    },
    "&:hover":{
      cursor: "pointer",
      backgroundColor:colors.error50,
      borderRadius: 8,
    },
  },
  sentInvitationBtn:{
    fontSize: "14px",
    color: colors.lightgreen,
    fontWeight:"500",
    lineHeight:"20px",
    padding:"10px"
  },
  svgIcon: {
    marginRight: "4px"
  },
  resendBtnLoadingState: {
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    border:`1px solid ${colors.darkGrey}`,
    backgroundColor: `${colors.brightBlue} !important`,
    color: colors.inactiveLightGrey,
    "& div:first-of-type": {
      marginLeft: 0,
      position: "initial",
      lineHeight: "12px",
      margin: "auto 0px"
    },
    "& span": {
      display: "none"
    }
  },
  revokeLoadingState: {
    backgroundColor: `${colors.error50} !important`,
    "& div:first-of-type": {
      marginLeft: 0,
      position: "initial",
      lineHeight: "12px",
      margin: "auto 0px",
      "& span:first-of-type": {
        borderColor: "rgb(145, 32, 24) rgb(145, 32, 24) transparent !important"
      },
    },
    "& span": {
      display: "none"
    },
  },
  confirmDeleteBtn:{
    whiteSpace: "nowrap",
    color:colors.darkRed,
    backgroundColor:colors.lightRed,
    border:"none",
    "&:hover":{
      border:"none",
      color:colors.intenseRed,
      backgroundColor:colors.pinkRed,
    },
    "&:focus":{
      color:colors.darkRed,
      border: `1px solid ${colors.lightRed}`,
      background: colors.lightRed,
      boxShadow: `0px 0px 0px 4px ${colors.pinkRed}, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)`,
    }
  },
  popoverDiv:{
    display:"flex",
    alignItems:"left",
    flexDirection:"column",
    backgroundColor:colors.white,
    padding: "6px",
    borderRadius: 8,
    color:colors.grey,
  },
  popoverTitle: {
    padding: "9px 10px",
    color: colors.inactiveGrey,
    fontFamily: theme.fontFamily,
    fontSize: "12px"
  },
  popover:{
    width:"240px",
    inset: "-10px auto auto -35px !important",
    "& .popover-arrow": {
      display:"none",
    },
    "& .popover-arrow::before": {
      border:"none",
    },
    border: "1px solid" + colors.lightGrey,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
  },
  email:{
    wordBreak: "break-all",
    textAlign: "justify",
    paddingRight: "10px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  emailDeteils:{
    fontFamily: theme.fontFamily,
    color: colors.mediumGrey,
    textAlign: "left"
  },
  travDetails: {
    margin: 0,
    display: "flex",
    justifyContent: "flex-start"
  },
  buttonsStyle:{
    "& div":{
      border:"none",
      backgroundColor:colors.white,
      color:colors.grey,
      padding:"9px 10px",
      fontSize: "14px",
      fontWeight:"500",
      lineHeight:"20px",
      fontFamily: theme.fontFamily,
    },
    "& img":{
      marginLeft:"14px"
    }
  },
  sortSelection: {   
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    "&:hover":{
      backgroundColor:colors.brightBlue,
      color:colors.grey,      
      borderRadius: "6px",
    },
    "& svg": {
      "& path": {
        stroke: theme.pendingInvitation.checkIconColor
      }
    }
  },
  pendingHeader:{
    display:"flex",
    alignItems:"flex-start",
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    height: "40px",
    width: "40px",
    padding: "10px",
    marginRight:"16px",
    border: theme.icon.border,
    borderRadius: theme.icon.borderRadius,
    boxShadow: theme.icon.boxShadow,
    backgroundColor: theme.icon.backgroundColor,
    "& svg": {
      display: "flex",
      "& path": {
        stroke: theme.icon.stroke
      }
    }
  },
  noInvitationsTitle:{
    fontFamily: theme.fontFamily,
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"24px",
  },
  noInviteText:{
    fontFamily: theme.fontFamily,
    fontSize: "14px",
    fontWeight:"400",
    lineHeight:"20px",
    color: colors.mediumGrey,
    marginTop: "30px"
  },
  moreContainer:{
    display:"flex",
    justifyContent:"flex-end",
    marginBottom:"30px",
  },
  firstRow: {
    display: "flex",
    width: "300px"
  },
  expiredPill: {
    height: "100%",
    padding: "2px 8px",
    borderRadius: "16px",
    backgroundColor: colors.yellow100,
    color: colors.grey,
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "18px",
  },
  multipleResendButtons: {
    display: "flex"
  },
  resendButton: {
    padding: "10px 18px",
    backgroundColor: theme.pendingInvitation.buttons.primary.backgroundColor,
    color: theme.pendingInvitation.buttons.primary.color,
    border: theme.pendingInvitation.buttons.primary.border,
    "& span": {
      whiteSpace: "nowrap"
    },
    "&:focus": {
      border: theme.pendingInvitation.buttons.primary.focus.border,
      backgroundColor: theme.pendingInvitation.buttons.primary.focus.backgroundColor,
      color: theme.pendingInvitation.buttons.primary.focus.color,
    },
    "&:hover": {
      boxShadow: theme.pendingInvitation.buttons.primary.hover.boxShadow,
      border: theme.pendingInvitation.buttons.primary.hover.border,
      backgroundColor: theme.pendingInvitation.buttons.primary.hover.backgroundColor,
      color: theme.pendingInvitation.buttons.primary.hover.color,
    }
  },
  cancelButton: {
    backgroundColor: theme.pendingInvitation.buttons.default.backgroundColor,
    color: theme.pendingInvitation.buttons.default.color,
    marginRight: "8px",
    "&:hover": {
      backgroundColor: theme.pendingInvitation.buttons.default.hover.backgroundColor,
      color: theme.pendingInvitation.buttons.default.hover.color,
    }
  },
  numberOfInvites: {
    display: "flex",
    justifyItems: "start"
  },
  totalInvitesText: {
    color: theme.pendingInvitation.color,
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center"
  },
  icon: {
    padding: "12px",
    marginRight: "16px",
    border: theme.pendingInvitation.icon.border,
    borderRadius: theme.icon.borderRadius,
    boxShadow: theme.icon.boxShadow,
    backgroundColor: theme.pendingInvitation.icon.backgroundColor,
    height: "48px",
    width: "48px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    "& svg": {
      "& path": {
        stroke: theme.pendingInvitation.icon.stroke
      }
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginRight: "0px",
      padding: "10px",
    },
  },
  multipleResendBar: {
    width: "-webkit-fill-available",
    padding: "12px 32px",
    height: "72px",
    backgroundColor: theme.pendingInvitation.backgroundColor,
    position: "absolute",
    bottom: 0,
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "8px 18px",
    }
  },
  gridHeader: {
    height: "44px",
    backgroundColor: colors.brightBlue,
    position: "sticky",
    top: 0,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    borderBottom: `1px solid ${colors.lightGrey}`,
    borderTop: `1px solid ${colors.lightGrey}`,
    zIndex: 1,
  },
  allCheckboxDiv: {
    display: "flex",
    marginRight: "12px",
    "& input":{
      appearance: "none",
      width: "20px",
      height: "20px",
      border: "1px solid " + colors.lightGrey,
      borderRadius: "6px",
      cursor: "pointer",
      backgroundColor: colors.white,
      marginRight: "auto",
      "&:checked": {
        border: "1px solid " + theme.colors.primary,
        backgroundColor: colors.white,
        backgroundSize: "10px 10px",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundOrigin:"content-box",
      }
    }
  },
  invitesSpinner: {
    position: "inherit",
    marginLeft: "20px",
    marginTop: '6px'

  },
  partiallySelected: {
    "& input":{
      "&:checked": {
        border: theme.checkbox.border,
        backgroundColor: theme.checkbox.backgroundColor,
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundColor: theme.checkbox.iconColor,
          maskImage: `url(${minusIcon})`,
          WebkitMaskImage: `url(${minusIcon})`,
          maskSize: "10px 10px",
          maskPosition: "center",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "10px 10px",
          WebkitMaskPosition: "center",
          WebkitMaskRepeat: "no-repeat",
        },
      }
    }
  },
  fullySelected: {
    "& input":{
      "&:checked": {
        border: theme.checkbox.border,
        backgroundColor: theme.checkbox.backgroundColor,
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundColor: theme.checkbox.iconColor,
          maskImage: `url(${checkIcon})`,
          WebkitMaskImage: `url(${checkIcon})`,
          maskSize: "10px 10px",
          maskPosition: "center",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "10px 10px",
          WebkitMaskPosition: "center",
          WebkitMaskRepeat: "no-repeat",
        },
      }
    }
  },
  showExpiredContainer: {
    display: "flex",
    padding: "12px 24px",
    height: "auto",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.grey
  },
  singleCheckboxDiv: {
    display: "flex",
    "& input":{
      appearance: "none",
      width: "20px",
      height: "20px",
      border: "1px solid " + colors.lightGrey,
      borderRadius: "6px",
      cursor: "pointer",
      backgroundColor: colors.white,
      marginRight: "auto",
    },
    marginRight: 0
  },
  singleSelected: {
    "& input":{
      "&:checked": {
        border: theme.checkbox.border,
        backgroundColor: theme.checkbox.backgroundColor,
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundColor: theme.checkbox.iconColor,
          maskImage: `url(${checkIcon})`,
          WebkitMaskImage: `url(${checkIcon})`,
          maskSize: "10px 10px",
          maskPosition: "center",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "10px 10px",
          WebkitMaskPosition: "center",
          WebkitMaskRepeat: "no-repeat",
        },
      }
    }
  },  
  headerColumns: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "58% 42%",
  },
  emailText: {
    display: "flex",
    textAlign: "left",
    fontSize: "12px",
    color: colors.mediumGrey,
    fontWeight:"500",
    lineHeight:"18px",
    padding:"12px",
    paddingLeft: "24px",
    fontStyle: "normal"
  },
  roleText: {
    extend: "emailText",
  },
  rowGeneralDiv: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "58% 42%",
    alignItems:"center",
    padding:"0px 24px",
    borderBottom: `1px solid ${colors.lightGrey}`,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      alignItems:"center",
    }
  },
  emailDiv: {
    display: "flex",
    alignItems: "center"
  },
  roleActionDiv: {
    display: "flex"
  },
  roleTextRow: {
    color: colors.lightBlack,
    fontWeight:"400",
    lineHeight:"20px",
    padding:"16px 28px",
    fontStyle: "normal",
    fontSize: "14px",
    textAlign: "left"
  },
  spacerDiv: {
    height: "60px"
  }
}));

export default styles;
